'use client';

import type { Dispatch, ReactNode } from 'react';
import React, { createContext, useContext, useReducer } from 'react';
import { rootReducer, initialRoot } from './reducers';
import type { OnboardingState, OnboardingAction } from './reducers/reducers.types';
interface OnboardingProviderProps {
  children: ReactNode;
}
type ContextType = {
  state: OnboardingState;
  dispatch: Dispatch<OnboardingAction>;
};
const OnboardingContext = createContext<ContextType | undefined>(undefined);
export const useOnboardingContext = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboardingContext must be used within an OnboardingProvider');
  }
  return context;
};
export const OnboardingProvider: React.FC<OnboardingProviderProps> = ({
  children
}) => {
  const [state, dispatch] = useReducer(rootReducer, initialRoot);
  const contextValue: ContextType = {
    state,
    dispatch
  };
  return <OnboardingContext.Provider value={contextValue} data-sentry-element="unknown" data-sentry-component="OnboardingProvider" data-sentry-source-file="index.tsx">
      {children}
    </OnboardingContext.Provider>;
};